import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { TextareaWithConfirm } from 'shared-components';

import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const VisaPrepFormFeedbackPage1 = (_props: any) => {
    const { t } = useTranslation('common');
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE8));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { otherFeedback, difficultiesFeedback } = visaPrepForm;

  // constants
  const currentStep = 1;
  const steps = 1;

  // component state
  const complete = true;

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Feedback'}
    >
      <TextareaWithConfirm
        key={VQ.OTHER_FEEDBACK}
        id={VQ.OTHER_FEEDBACK}
        value={otherFeedback}
        label={t('common:isThereAnyOtherInformationYouWis')}
        onChange={(evt: any) => onChange(VQ.OTHER_FEEDBACK, evt.currentTarget.value)}
      />

      <TextareaWithConfirm
        key={VQ.DIFFICULTIES_FEEDBACK}
        id={VQ.DIFFICULTIES_FEEDBACK}
        value={difficultiesFeedback}
        label={t('common:ifYouHaveAnyDifficultiesWithAnyQ')}
        onChange={(evt: any) => onChange(VQ.DIFFICULTIES_FEEDBACK, evt.currentTarget.value)}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormFeedbackPage1;
